"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-a-vico": {
    "aefe0280": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e0d0d16": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "maielli": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f391ff4": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "mandre": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20e3ebfc": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "messercola": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1cc8b34": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "papi": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "784c7a54": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "priori": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5434b741": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "rosciano": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "befe2c4f": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "6333300f",
      "slug": "santa-maria-a-vico",
      "name": "Santa Maria a Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;